import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'SUBSCRIBER_UPDATE',
    smsDelete : 'SUBSCRIBER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        subscriber: [],
        subscriber_count: null,
        subscriberLoading: false,
        subscriberError: false,

        history: {},
        historyLoading: false,
        historyError: false,

        payment_initiated: [],
        payment_initiated_count: null,

        expiring_soon: [],
        expiring_soon_count: null,

        activated: [],
        activated_count: null,

        expired: [],
        expired_count: null,

        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SUBSCRIBER(state, {results, count}) {
            state.subscriber = results;
            state.subscriber_count = count;
        },

        SUBSCRIBER_LOADING (state, loading) {
            state.subscriberLoading = loading;
        },

        SUBSCRIBER_ERROR (state, hasError) {
            state.subscriberError = hasError;
        },

        SET_HISTORY(state, items) {
            state.history = items;
        },

        HISTORY_LOADING (state, loading) {
            state.historyLoading = loading;
        },

        HISTORY_ERROR (state, hasError) {
            state.historyError = hasError;
        },

        SET_PAYMENT_INITIATED(state, {results, count}) {
            state.payment_initiated = results;
            state.payment_initiated_count = count;
        },

        SET_EXPIRING_SOON(state, {results, count}) {
            state.expiring_soon = results;
            state.expiring_soon_count = count;
        },

        SET_ACTIVATED(state, {results, count}) {
            state.activated = results;
            state.activated_count = count;
        },

        SET_EXPIRED(state, {results, count}) {
            state.expired = results;
            state.expired_count = count;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async fetchSubscriber ({ commit }, payload) { 
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);

                let url = V1API.subscriber_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_SUBSCRIBER', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async deleteSubscriber({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.subscriber_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchSubscriber', {perPage: payload.perPage, currentPage: payload.currentPage})
            return response
        },

        async fetchHistory ({ commit }, payload) { 
            commit('HISTORY_LOADING', true);
            commit('HISTORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let url = V1API.subscriber_history + '?user_id=' + payload;
                let result = await axios.get(url, config);
                const items = result.data
                commit('SET_HISTORY', items);
                return result
            } catch(error) {
                commit('HISTORY_ERROR', true);
            } finally {
                commit('HISTORY_LOADING', false);
            }
        },

        async fetchPaymentInitiated ({ commit }, payload) { 
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);

                let url = V1API.payment_initiated_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_PAYMENT_INITIATED', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async fetchExpiringSoon ({ commit }, payload) { 
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.type) params.append('type', payload.type);
                if (payload.package) params.append('package', payload.package);

                let url = V1API.expiring_soon_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_EXPIRING_SOON', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async fetchActivated ({ commit }, payload) {
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.type) params.append('type', payload.type);
                if (payload.package) params.append('package', payload.package);

                let url = V1API.activated_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_ACTIVATED', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        },

        async fetchExpired ({ commit }, payload) {
            commit('SUBSCRIBER_LOADING', true);
            commit('SUBSCRIBER_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.type) params.append('type', payload.type);
                if (payload.package) params.append('package', payload.package);

                let url = V1API.expired_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, count} = result.data
                commit('SET_EXPIRED', {results, count});
                return result
            } catch(error) {
                commit('SUBSCRIBER_ERROR', true);
            } finally {
                commit('SUBSCRIBER_LOADING', false);
            }
        }
    },

    getters: {}
}
